import Panel from "./panel"
export default Panel



/** WEBPACK FOOTER **
 ** ./es2015/controls/panel/index.js
 **/